import { supabase } from "@/integrations/supabase/client";
import { handleSupabaseFunctionError } from "@/utils/supabaseFunctionsError";
import type {
  CompanyPreviewParams,
  CompanyPreviewResponse,
} from "@/api/types/companyPreview";

export async function getCompanyPreview(
  params: CompanyPreviewParams
): Promise<CompanyPreviewResponse> {
  const { data, error } = await supabase.functions.invoke(
    `api/company-preview?cui=${encodeURIComponent(params.cui)}`,
    { method: "GET" }
  );

  await handleSupabaseFunctionError(error);
  return data;
}
